import React from 'react'
import { TextAreaInputField } from 'components/inputs/TextAreaInputField'
import { IInitialRequestEditsFormModal } from './useRequestEditsFormModal'
import { BaseModal } from 'components/modals/BaseModal'
import { ProductSearchResult } from 'models/SearchResult'
import { User } from 'hooks/useUsers'


export const RequestEditsFormModal = ({ 
    requestEditsFormModal,
    product,
    loggedInUser
}:{
    requestEditsFormModal: IInitialRequestEditsFormModal,
    product: ProductSearchResult,
    loggedInUser: User

 }) => {

    const { isModalActive, isLoading, onCancel, formState, onChange, onConfirm } = requestEditsFormModal

  return (
    <BaseModal
        isModalActive={isModalActive}
        modalTitle={`Request Edits`}
        onCancelModal={onCancel}>
            
            <form>

            <TextAreaInputField
                fieldLabel={`Add a comment`}
                onChange={onChange}
                fieldName={'comment'}
                value={formState.comment}
                errorValue={null}
                isOptional={true}
                helpText={`Request edits comment.`} />

            <div className="field is-grouped is-pulled-right">
                <div className="control">
                    <button className={`button is-link ${isLoading ? `is-loading` : ``}`} onClick={(e) => onConfirm(e, product,loggedInUser )}>Confirm</button>
                </div>
                <div className="control">
                    <button className="button is-link is-light" onClick={(e) => onCancel(e)}>Cancel</button>
                </div>
            </div>

            </form>

    </BaseModal>

  )
}
